import React, { useState, useEffect } from "react";
import { ChevronDown } from "lucide-react";

export default function ServiceFAQ({ faqs, serviceTitle }) {
  const [openIndex, setOpenIndex] = useState(null);

  // Inject FAQ Schema (JSON-LD) into head
  useEffect(() => {
    if (!faqs || !faqs.length) return;
    const schema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map((faq) => ({
        "@type": "Question",
        "name": faq.q,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.a,
        },
      })),
    };
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "faq-schema";
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => { const el = document.getElementById("faq-schema"); if (el) el.remove(); };
  }, [faqs]);

  if (!faqs || !faqs.length) return null;

  return (
    <div data-testid="service-faq-section">
      <h2 className="text-2xl font-bold text-slate-800 mb-6">Frequently Asked Questions</h2>
      <div className="space-y-3">
        {faqs.map((faq, idx) => (
          <div
            key={idx}
            className="border border-slate-200 rounded-xl overflow-hidden hover:border-cyan-300 transition-colors duration-300"
          >
            <button
              onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              className="w-full flex items-center justify-between px-6 py-4 text-left"
              data-testid={`faq-question-${idx}`}
            >
              <span className="text-slate-800 font-medium pr-4">{faq.q}</span>
              <ChevronDown
                className={`w-5 h-5 text-slate-400 flex-shrink-0 transition-transform duration-300 ${
                  openIndex === idx ? "rotate-180 text-cyan-500" : ""
                }`}
              />
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                openIndex === idx ? "max-h-96 pb-4" : "max-h-0"
              }`}
            >
              <p className="px-6 text-slate-600 leading-relaxed">{faq.a}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
